const DELAY = 100;

/**
 * Funkce na osetrenie situacii kedy neni definovana promenna -> napr. pri pouzivani globanych promennych v sablone
 * v intervaloch kontroluje ci sa nedefinovala nasledne zavola callback ktoremu preda hodnotu promennej ako prvy argument parameter
 *
 * @param context
 * @param property
 * @param callback
 * @param accessor - mozem definovat vlastu funkci na pristup k property napr. wait(dacument, 'elementId', () => {}, document.getElementById)
 * @param timeout - max doba ktoru budeme cakat na promennu
 */
export default function(context, property, callback, accessor = null, timeout = null) {
  (function check() {
    let value = accessor ? accessor.call(context, property) : context[property];
    if (typeof value === 'undefined' || value === null) {
      // je nastaveny timeout
      if (timeout !== null) {
        // timeout vyprsal
        if (timeout <= 0) {
          // eslint-disable-next-line no-throw-literal
          throw `Property ${property} not defined.`;
        }
        else {
          timeout -= DELAY;
        }
      }
      setTimeout(check, DELAY);
    }
    else {
      callback(value);
    }
  })();
};
